<template>
  <!-- <tbody> -->
  <tr class="text-sm">
    <td class="py-2 px-3 border border-l-0" />
    <td class="py-2 px-3 border" />
    <td class="py-2 px-3 align-top border">
      {{ gaAd.name || `Ad ${gaAd.id}` }}
    </td>
    <td class="py-2 align-top px-3 border text-right">
      {{ gaAdTotalsFormatted.impressions }}
      <br />
      {{ gaAdTotalsFormatted.cpi }}
    </td>
    <td class="py-2 align-top px-3 border text-right">
      {{ gaAdTotalsFormatted.interactions }}
      <br />
      {{ gaAdTotalsFormatted.cpr }}
    </td>
    <td class="py-2 align-top px-3 border text-right">-</td>
    <td class="py-2 align-top px-3 border text-right">
      {{ gaAdTotalsFormatted.clicks }}
      <br />
      {{ pageviewsPerImpression }}% / {{ costPerPageView }}
    </td>
    <td class="py-2 align-top px-3 border text-right">-</td>
    <td class="py-2 align-top px-3 border border-r-0 text-right">
      {{ gaAdTotalsFormatted.cost }}
    </td>
  </tr>
  <!-- </tbody> -->
</template>

<script>
import Numbro from '@/utils/numbro';

export default {
  props: {
    gaAd: { type: Object, required: true },
    gaAdReport: { type: Object, default: () => ({}) },
  },
  computed: {
    gaAdTotals() {
      return {
        impressions: 0,
        cost_micros: 0,
        clicks: 0,
        engagements: 0,
        interactions: 0,
        ...(this.gaAdReport || {}),
      };
    },
    gaAdTotalsFormatted() {
      const impressions = this.gaAdTotals?.impressions || 0;
      const clicks = this.gaAdTotals?.clicks || 0;
      const engagements = this.gaAdTotals?.engagements || 0;
      const interactions = this.gaAdTotals?.interactions || 0;
      const cost = (this.gaAdTotals?.cost_micros || 0) / 1_000_000;
      const cpi = impressions ? 1000 * (cost / impressions) : 0;
      const cpr = interactions ? 1000 * (cost / interactions) : 0;

      return {
        impressions: Numbro(impressions).format({ thousandSeparated: true }),
        clicks: Numbro(clicks).format({ thousandSeparated: true }),
        engagements: Numbro(engagements).format({ thousandSeparated: true }),
        interactions: Numbro(interactions).format({ thousandSeparated: true }),
        cost: Numbro(cost).formatCurrency({ thousandSeparated: true, mantissa: 2 }),
        cpi: Numbro(cpi).formatCurrency({ thousandSeparated: true, mantissa: 2 }),
        cpr: Numbro(cpr).formatCurrency({ thousandSeparated: true, mantissa: 2 }),
      };
    },
    pageviewsPerImpression() {
      const { impressions, clicks } = this.gaAdTotals;
      if (!impressions) return 0;
      return Numbro((clicks / impressions) * 100).format({ thousandSeparated: true, mantissa: 2 });
    },
    costPerPageView() {
      const { clicks } = this.gaAdTotals;
      const cost = (this.gaAdTotals?.cost_micros || 0) / 1_000_000;
      if (!clicks) return 0;
      return Numbro(cost / clicks).formatCurrency({ thousandSeparated: true, mantissa: 2 });
    },
  },
};
</script>
